import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'users';

class UserService {
    getUsers() {
        return axios.get(API_URL, {headers: authHeader() });
    }
    updateUser(user){
        return axios.put(API_URL + '/' + user.id, {
            isActive: user.isActive,
            roles: user.roles
        }, {headers: authHeader() })
    }
}

export default new UserService();